import { useEffect } from "react";

/**
 * Lightweight per-page SEO hook. Sets title, description, canonical, and OG tags.
 * No external dependency. Safe to call multiple times.
 */
export function useSeo({ title, description, canonical, image }) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (selector, attr, value) => {
            if (!value) return;
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                const [key, val] = selector
                    .replace(/[\[\]"]/g, "")
                    .split("=");
                el.setAttribute(key, val);
                document.head.appendChild(el);
            }
            el.setAttribute(attr, value);
        };

        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[property="og:title"]', "content", title);
        setMeta('meta[property="og:description"]', "content", description);
        setMeta('meta[name="twitter:title"]', "content", title);
        setMeta('meta[name="twitter:description"]', "content", description);
        if (image) {
            setMeta('meta[property="og:image"]', "content", image);
            setMeta('meta[name="twitter:image"]', "content", image);
        }

        if (canonical) {
            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
            setMeta('meta[property="og:url"]', "content", canonical);
        }
    }, [title, description, canonical, image]);
}
